import { Badge } from '@safetyhub/ui';

export interface StepperStep {
  key: string;
  label: string;
  optional?: boolean;
}

interface SiteFormStepperProps {
  steps: StepperStep[];
  currentIndex: number;
}

export function SiteFormStepper({ steps, currentIndex }: SiteFormStepperProps) {
  return (
    <nav aria-label="현장 생성 단계" className="mb-4">
      <ol className="flex items-center gap-2 min-w-0">
        {steps.map((step, idx) => {
          const isActive = idx === currentIndex;
          const isDone = idx < currentIndex;
          const isLast = idx === steps.length - 1;
          return (
            <li key={step.key} className="flex items-center gap-2 min-w-0 flex-1">
              <div
                className={`flex items-center gap-1.5 min-w-0 ${
                  isActive ? 'font-semibold' : ''
                }`}
                aria-current={isActive ? 'step' : undefined}
              >
                <span
                  className={`flex h-6 w-6 items-center justify-center rounded-full border text-xs font-medium flex-shrink-0 ${
                    isActive
                      ? 'bg-brand-600 text-white border-brand-600'
                      : isDone
                        ? 'bg-brand-100 text-brand-700 border-brand-300'
                        : 'bg-white text-ink-500 border-ink-300'
                  }`}
                >
                  {idx + 1}
                </span>
                <span
                  className={`text-xs sm:text-sm truncate ${
                    isActive
                      ? 'text-brand-700'
                      : isDone
                        ? 'text-ink-700'
                        : 'text-ink-500'
                  }`}
                >
                  {step.label}
                </span>
                {step.optional && (
                  <span aria-label="선택 단계">
                    <Badge tone="slate" shape="rounded" size="sm" className="ml-0.5 flex-shrink-0">
                      선택
                    </Badge>
                  </span>
                )}
              </div>
              {!isLast && (
                <span
                  className={`flex-1 h-px ${
                    isDone ? 'bg-brand-300' : 'bg-ink-200'
                  }`}
                  aria-hidden="true"
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
